var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSuccessTransferWallet = function SvgSuccessTransferWallet(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "77px",
    height: "41px",
    viewBox: "0 0 77 41",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "journey_transfer_wallet copy")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "current",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.6.3-Transfer",
    transform: "translate(-141.000000, -233.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(140.000000, 209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(3.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/circle_tick_success",
    transform: "translate(52.666667, 16.666667)",
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 Z M15.9900918,7.39053429 C15.4693982,6.86982971 14.6251783,6.86982076 14.1044737,7.39051429 L14.1044737,7.39051429 L9.90436364,11.5895879 L8.27614237,9.96180914 L8.15053259,9.850891 C7.62747765,9.44419114 6.87116957,9.48116386 6.39052429,9.96180914 C5.86982524,10.4825082 5.86982524,11.3267282 6.39052429,11.8474272 L6.39052429,11.8474272 L9.90459606,15.361499 L15.9900718,9.27615237 L16.1009912,9.15054377 C16.5076966,8.62749314 16.470732,7.87118467 15.9900918,7.39053429 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.000000)",
    stroke: "current",
    strokeWidth: 2.5,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/send_money",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9388753,4.37423743 L12.9388753,2.50305623 C12.9388753,1.12065645 14.0595318,0 15.4419315,0 L60.4969438,0 C61.8793436,0 63,1.12065645 63,2.50305623 C63,7.53391769 63,10.3070638 63,12.8224945 M49.3843638,27.5336186 C41.3971566,27.5336186 31.4163459,27.5336186 15.4419315,27.5336186 C14.0595318,27.5336186 12.9388753,26.4129621 12.9388753,25.0305623 L12.9388753,22.5372837",
    id: "Shape",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.547066,
    cy: 14.8257946,
    r: 6.73899756
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.85085575,
    y1: 8.25045844,
    x2: 17.3866137,
    y2: 8.25045844,
    id: "Line-3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,13.2565709 C0,13.2565709 7.12408313,13.2565709 21.3722494,13.2565709",
    id: "Line-3-Copy",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.86415037,
    y1: 18.2626834,
    x2: 18.1279034,
    y2: 18.2626834,
    id: "Line-3-Copy-2",
    strokeLinecap: "round"
  })))))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccessTransferWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success_transfer_wallet.0031326a.svg";
export { ForwardRef as ReactComponent };